import { FC } from 'react';

import { useTitle } from '../hooks/useTitle';

import FavoriteList from 'src/components/organisms/FavoriteList/FavoriteList';

const FavoritePage: FC = () => {
  useTitle('GU | 즐겨찾기');
  return <FavoriteList />;
};

export default FavoritePage;
